/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import * as types from '../actions/actionTypes';

var initialState = {geoLocation:{selectedPuff: null, lat:35, long:18, zoom:3}}

const app = function(state = initialState, action) {

  switch(action.type) {
    case types.SET_GEOLOCATION:
      return Object.assign({}, state, { geoLocation: action.geoLocation });
  }

  return state;

}

export default app;


